import { Modal, Form, Tooltip } from "antd";
import { CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  Flex,
  Dropdown,
  Spin,
  Menu,
  TabsProps,
  Input,
  Select,
  Avatar,
  notification,
} from "antd";
import InsigthButton from "components/Common/Button/InsigthButton";
import { Title3, Title4 } from "components/Common/Typography/Titles";
import {
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  PieChartOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { SvgIcons } from "Icon/SvgIcons";
import arrowdown from "../../images/arrowdown.svg";
import candidateIcon from "../../images/candidate_icon.svg";
import fingerprintIcon from "../../images/fingerprintIcon.svg";
import { FaEdit, FaHamburger } from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
import saveSearch from "../../images/save.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSSR } from "react-i18next";
import { IoMdArrowDropdown } from "react-icons/io";
import {
  addProjectContributors,
  createProject,
  deleteProjectContributors,
  fetchAllContributors,
  fetchProjectContributors,
} from "api/project.api";
import AvatarIcon from "../../images/Logomark.png";
import { getProjects } from "api/project.api";
import { useDispatch, useSelector } from "react-redux";
import { setcandidateSelectedPool } from "store/slices/candidateScreening";
import { EditIcon } from "icons/Icons";
import { UsersPlusIcon } from "icons/Icons";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import LimitedAccessModal from "./LimitedAccessModal";
const FaEditSin = FaEdit as unknown as React.FC as any;
const FaHamburgerSin = FaHamburger as unknown as React.FC as any;
const BsSearchSin = BsSearch as unknown as React.FC as any;
const IoMdArrowDropdownSin = IoMdArrowDropdown as unknown as React.FC as any;
interface ProjectSavedSearchesSecondHeaderProps {
  selectedPool: number;
  addTab: (tabNumber: number) => void;
  currentIndex: number;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
}

const menu = (
  <Menu>
    <Menu.Item key="OPEN">Open</Menu.Item>
    <Menu.Item key="ON_HOLD">On Hold</Menu.Item>
    <Menu.Item key="COMPLETE">Completed</Menu.Item>
    <Menu.Item key="CANCELLED">Cancelled</Menu.Item>
  </Menu>
);

interface talentPoolFormData {
  id: number;
  name: string;
}

type Contributor = {
  id: number;
  name: string;
  email: string;
};

// Define the TalentPool interface
export interface TalentPool {
  id: number;
  owner: string;
  role?: string;
  totalCandidates: number; // Add this field
}

// Define the types for the options
interface CandidateOption {
  value: string;
  label: React.ReactNode;
}

interface FormItem {
  label: string;
  icon?: React.ReactNode;
  name: string;
  placeholder: string;
  prefixIcon?: React.ReactNode;
  options?: CandidateOption[] | TalentPool[];
  type?: string;
}

const ProjectSavedSearchesSecondHeader: React.FC<ProjectSavedSearchesSecondHeaderProps> = ({
  selectedPool,
  addTab,
  currentIndex,
  setCurrentIndex,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [contributors, setContributors] = useState<Contributor[]>([]);
  const [projectContributors, setProjectContributors] = useState<Contributor[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLimitedAccessModalVisible, setIsLimitedAccessModalVisible] = useState(false);
  const [modalType, setModalType] = useState<"Contributor" | "TalentPool" | null>(null);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [addTalentPoolTab, setAddTalentPoolTab] = useState<talentPoolFormData[]>([]);
  const [deleteLoading, setDeleteLoading] = useState<number>(); // Specify type here
  const [selectedContributors, setSelectedContributors] = useState<Contributor | null>(null);
  const [addedContributor, setAddedContributor] = useState<Contributor[]>([]);
  // const [deletedContributor, setDeletedContributor] = useState<Contributor[]>([]);
  const [deletedContributor, setDeletedContributor] = useState<number | null>(null);
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState<"1" | "2" | null>(null);
  const [formData, setFormData] = useState({ name: "", jobTitle: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [addProjectLoading, setAddProjectLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [talentPools, setTalentPools] = useState<TalentPool[]>([]);
  const [selectedPools, setSelectedPools] = useState<number[]>([]);
  const [poolName, setPoolName] = useState<any>("");
  const [selectedPoolss, setSelectedPool] = useState<any>("");
  const projectDetails = useSelector((state: any) => state.projectSlice?.selected_project || {});
  const isEditAllowed = projectDetails.actions_allowed?.edit;
  const isAddContributorsAllowed = projectDetails.actions_allowed?.add_contributors;
  const isScreeningFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCSI);

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/analytics")) {
      setCurrentIndex(1);
    } else if (location.pathname.includes("/wise/recent-searches")) {
      setCurrentIndex(3);
    } else if (location.pathname.includes("/wise/saved-searches")) {
      setCurrentIndex(2);
    } else if (location.pathname.includes("/screening")) {
      setCurrentIndex(2);
    } else if (location.pathname.includes("/talent-pool")) {
      setCurrentIndex(4);
    } else if (location.pathname.includes("/details")) {
      setCurrentIndex(9);
    } else if (location.pathname.includes("/report-list")) {
      setCurrentIndex(10);
    }
  }, [location.pathname]);

  const handleDashboardClick = (event: React.MouseEvent<HTMLElement>): void => {
    addTab(currentIndex);
    setCurrentIndex(1);
    navigate(`/projects/analytics/${selectedPool}`);
  };

  const handleRecentClick = (event: React.MouseEvent<HTMLElement>): void => {
    addTab(currentIndex);
    setCurrentIndex(3);
    navigate(`/projects/wise/recent-searches/${selectedPool}`);
  };
  const handleReportsClick = () => {
    addTab(currentIndex);
    setCurrentIndex(3);
    navigate(`/projects/report-list/${selectedPool}`);
  };
  const handleSavedClick = (event: React.MouseEvent<HTMLElement>): void => {
    addTab(currentIndex);
    setCurrentIndex(2);
    navigate(`/projects/wise/saved-searches/${selectedPool}`);
  };

  const handleScreeningClick = (event: React.MouseEvent<HTMLElement>): void => {
    addTab(currentIndex);
    setCurrentIndex(25);
    navigate(`/projects/screening/${selectedPool}`);
  };
  // const handleTalentPoolClick = (event: React.MouseEvent<HTMLElement>): void => {
  //     addTab(currentIndex);
  //     setCurrentIndex(3);
  //     navigate(`/projects/recent-searches/${selectedPool}`);
  // };

  // const handleTalentPoolClick = (event: React.MouseEvent<HTMLElement>): void => {
  //     addTab(currentIndex);
  //     setCurrentIndex(4);
  //     navigate(`/projects/talent-pool/${selectedPool}`);
  // };

  const handleTalentPoolClick = (poolId: number, poolIndex: number) => {
    addTab(poolIndex + 4); // Offset to match your tab numbering
    setCurrentIndex(poolIndex + 4); // Update currentIndex dynamically
    navigate(`/projects/talent-pool/${poolId}`);
  };

  const handleProjectDetailsClick = (event: React.MouseEvent<HTMLElement>): void => {
    addTab(currentIndex);
    setCurrentIndex(99);
    navigate(`/projects/details/${selectedPool}`);
  };

  const fetchAllContributor = async () => {
    try {
      setLoading(true);
      const response: any = await fetchAllContributors(selectedPool);
      setContributors(response); // Store response directly
    } catch (error) {
      console.error("Error fetching contributor list:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectContributor = async () => {
    try {
      setLoading(true);
      const response: any = await fetchProjectContributors(selectedPool);
      setProjectContributors(response.results); // Store response directly
    } catch (error) {
      console.error("Error fetching contributor list:", error);
    } finally {
      setLoading(false);
    }
  };

  const showModal = (type: "Contributor" | "TalentPool") => {
    setModalType(type);
    setIsModalVisible(true);
  };

  const handleAddContributor = async () => {
    if (selectedContributors) {
      // Wait for form validation
      const { email } = await form.validateFields();
      const contributorId: number | undefined = selectedContributors?.id;
      if (!contributorId) {
        console.error("No contributor ID is selected.");
        return; // Exit if there's no valid contributor ID
      }
      try {
        setLoading(true);
        const response = await addProjectContributors([selectedPool], [contributorId]);
        setAddedContributor((prev) => [...prev, selectedContributors]);
        // Reset the form and toggle modals
        form.resetFields();
        setIsModalVisible(false); // Close the main modal
        setIsSuccessModalVisible(true); // Show the success modal
      } catch (errorInfo) {
        console.error("Validation Failed or Async Error:", errorInfo);
      } finally {
        setLoading(false);
      }
    } else {
      console.error("No contributor selected to add.");
    }
  };

  const handleAddTalentPool = async () => {
    try {
      setLoading(true);
      // Wait for form validation
      const { name } = await form.validateFields();

      // Prepare the FormData
      const newPipelineData = new FormData();
      newPipelineData.append("role", "Add new talent Pool");
      newPipelineData.append("title", name);

      // Await the response from createProject
      const response = await createProject(newPipelineData);

      // Create a new talent pool object
      const newTalentPool: talentPoolFormData = {
        id: response?.id, // Ensure `id` exists in response
        name: name,
      };

      // Update state with the new talent pool
      setAddTalentPoolTab([...addTalentPoolTab, newTalentPool]);

      // Reset the form and close modal
      form.resetFields();
      setIsModalVisible(false);

      // Optionally show a success modal or notification
      setIsSuccessModalVisible(true);

      console.log("Successfully added:", name, response);
    } catch (errorInfo) {
      // Handle validation or API call errors
      console.error("Error adding talent pool:", errorInfo);
    } finally {
      setLoading(false);
    }
  };

  const deleteAPIProjectContributors = async (contributorId: number) => {
    try {
      setDeleteLoading(contributorId); // Set loading for the specific contributor
      const response = await deleteProjectContributors([selectedPool], [contributorId]);
      // setDeletedContributor((prevContributors) =>
      //     prevContributors.filter(contributor => contributor.id !== contributorId)
      // );
      setDeletedContributor(contributorId);
      setContributors((prevContributors) =>
        prevContributors.filter((contributor) => contributor.id !== contributorId)
      );
    } catch (error) {
      console.error("Error fetching contributor list:", error);
    } finally {
      // setDeleteLoading(false);
      setDeleteLoading(0); // Reset loading state
    }
  };

  const handleDeleteContributor = (contributorId: number) => {
    deleteAPIProjectContributors(contributorId);
  };

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const { name, value } = e.target;
  //     setFormData({ ...formData, [name]: value });
  //     if (name === "searchTerm") {
  //       setSearchTerm(value.toLowerCase());
  //     }
  // };

  const contributerEmails = (
    // <Spin spinning={loading}>
    <Menu
      style={{
        maxHeight: "200px", // Limits the dropdown height
        overflow: "hidden", // Ensures only the list scrolls, not the entire Menu
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ccc", // Add border to Menu
        borderRadius: "4px", // Optional rounded corners
      }}
    >
      {projectContributors.length > 0 && (
        <>
          <div
            style={{
              flex: 1,
              overflowY: "auto", // Enables vertical scrolling for the list
            }}
          >
            {projectContributors.map((contributor) => (
              // <Menu.Item key={contributor.id}>
              <Menu.Item
                key={contributor.id}
                style={{
                  borderBottom: "1px solid #e0e0e0", // Divider between rows
                  padding: "8px 16px", // Spacing for better readability
                }}
              >
                {/* <Spin spinning={deleteLoading} size="small"> */}
                <Spin spinning={deleteLoading === contributor.id} size="small">
                  {/* <div className="flex justify-between items-center">
                                    <span>{contributor.name}, {contributor.email}</span>
                                        <DeleteOutlined 
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevents the dropdown from closing
                                                handleDeleteContributor(contributor.id); // Call the delete function
                                            }}
                                            style={{ color: 'gray', cursor: 'pointer', marginLeft: "5px" }} 
                                        />
                                    
                                </div> */}
                  <div
                    className="flex justify-between items-center"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      {contributor.name && <><strong>{contributor.name}</strong>,</>} {contributor.email}
                    </span>
                    <DeleteOutlined
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the dropdown from closing
                        handleDeleteContributor(contributor.id); // Call the delete function
                      }}
                      style={{
                        color: "gray",
                        cursor: "pointer",
                        marginLeft: "5px",
                      }}
                    />
                  </div>
                </Spin>
              </Menu.Item>
            ))}
          </div>
          <Menu.Divider />
        </>
      )}
      <Menu.Item
        key="action_contributor"
        onClick={() => showModal("Contributor")}
        style={{
          position: "sticky", // Keeps this item fixed at the bottom
          bottom: 0,
          background: "white",
          zIndex: 1,
          // borderTop: '1px solid #ccc', // Add top border to this item
          textAlign: "start", // Center align for clarity
        }}
      >
        <PlusOutlined /> <span style={{ fontWeight: "bold" }}>Team Contributor</span>
      </Menu.Item>
      <Menu.Item
        key="limited_access"
        onClick={() => setIsLimitedAccessModalVisible(true)}
        style={{
          position: "sticky", // Keeps this item fixed at the bottom
          bottom: 0,
          background: "white",
          zIndex: 1,
          // borderTop: '1px solid #ccc', // Add top border to this item
          textAlign: "start", // Center align for clarity
        }}
      >
        <PlusOutlined /> <span style={{ fontWeight: "bold" }}>External Contributor</span>
      </Menu.Item>
    </Menu>
    // </Spin>
  );

  useEffect(() => {
    if (deletedContributor) {
      fetchAllContributor();
      fetchProjectContributor();
      setDeletedContributor(null);
    }
  }, [deletedContributor]);

  useEffect(() => {
    fetchAllContributor();
    // fetchProjectContributor();
  }, [selectedPool, addedContributor]);
  // }, [selectedPool, addedContributor]);

  useEffect(() => {
    fetchProjectContributor();
  }, [addedContributor]);

  const formDetails: Record<string, FormItem[]> = {
    "1": [
      {
        label: "Create Talent Pool",
        // icon: SvgIcons.questionSvg,
        name: "name",
        placeholder: "Talent Pool Name",
        type: "input",
      },
      // {
      //   label: "Select Job title",
      //   icon: SvgIcons.questionSvg,
      //   name: "jobTitle",
      //   placeholder: "Start typing",
      //   options: jobTitles,
      // },
    ],
    "2": [
      {
        label: "Search Talent Pool",
        icon: SvgIcons.questionSvg,
        name: "searchTerm",
        placeholder: "Start typing",
        type: "input",
        // prefixIcon: SvgIcons.userSvg,
        // options: candidate,
      },
      // {
      //   label: "Select Job title",
      //   icon: SvgIcons.questionSvg,
      //   name: "jobTitle",
      //   placeholder: "Start typing",
      //   options: jobTitles,
      // },
    ],
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "searchTerm") {
      setSearchTerm(value.toLowerCase());
    }
  };

  const handleSelectChange = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value });
  };

  const fetchTalentPools = async () => {
    if (page === 1) {
      setLoading(true);
    }
    try {
      const data = await getProjects(page);
      setTotalPages(data?.total_pages);
      const formattedData = data?.results.map((pool) => ({
        id: pool.id,
        owner: pool.title,
        role: pool.description || "No Project",
        totalCandidates: pool.shortlisted_candidates,
      }));
      setTalentPools([...talentPools, ...formattedData]);
      if (formattedData.length > 0 && page === 1) {
        dispatch(setcandidateSelectedPool(formattedData[0].id));
        setSelectedPool(formattedData[0].id);
        setPoolName(formattedData[0].owner);
      }
      setPage(page + 1);
    } catch (error) {
      console.error("Error fetching talent pools:", error);
    } finally {
      setLoading(false);
    }
  };

  const refreshTalentPools = async () => {
    setLoading(true);
    try {
      const data = await getProjects(1);
      setTotalPages(data?.total_pages);
      const formattedData = data?.results.map((pool) => ({
        id: pool.id,
        owner: pool.title,
        role: pool.description || "No Project",
        totalCandidates: pool.shortlisted_candidates,
      }));
      setTalentPools(formattedData);
      if (formattedData.length > 0) {
        dispatch(setcandidateSelectedPool(formattedData[0].id));
        setSelectedPool(formattedData[0].id);
        setPoolName(formattedData[0].owner);
      }
      setPage(2);
    } catch (error) {
      console.error("Error fetching talent pools:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshTalentPools();
  }, []);

  const handleSave = async () => {
    try {
      setAddProjectLoading(true);
      const newPipelineData = new FormData();
      newPipelineData.append("role", "Add new talent Pool");
      newPipelineData.append("title", formData.name);

      const response = await createProject(newPipelineData);

      // Refresh the talent pools list after adding a new pipeline
      await fetchTalentPools();
      setActiveKey(null);
      setFormData({ name: "", jobTitle: "" });
      if (response) {
        notification.success({
          message: "Success",
          description: "Successfully Added New Talent Pool.",
        });
        refreshTalentPools();
      }
    } catch (error) {
      console.error("Error adding pipeline:", error);
      notification.success({
        message: "Error",
        description: "Error In Adding New Talent Pool.",
      });
    } finally {
      setAddProjectLoading(false);
    }
  };

  const handleSearch = () => {
    console.log("Search clicked");
  };

  return (
    <>
      <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
        <div className="flex gap-2 items-center">
          <Button
            type="text"
            onClick={handleDashboardClick}
            className={currentIndex === 1 ? "active-tab" : ""}
          >
            <PieChartOutlined style={{ fontSize: "20px" }} />
            Dashboard
          </Button>
          <div className="h-6 border-l border-main-border"></div>
          <Button
            type="text"
            onClick={handleSavedClick}
            className={currentIndex === 2 ? "active-tab" : ""}
          >
            {/* <img src={saveSearch} alt="" style={{ fontSize: "20px" }} /> */}
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.83333 3V5.83333C5.83333 6.30004 5.83333 6.5334 5.92416 6.71166C6.00406 6.86846 6.13154 6.99594 6.28834 7.07584C6.4666 7.16667 6.69996 7.16667 7.16667 7.16667H12.8333C13.3 7.16667 13.5334 7.16667 13.7117 7.07584C13.8685 6.99594 13.9959 6.86846 14.0758 6.71166C14.1667 6.5334 14.1667 6.30004 14.1667 5.83333V3.83333M14.1667 18V12.6667C14.1667 12.2 14.1667 11.9666 14.0758 11.7883C13.9959 11.6315 13.8685 11.5041 13.7117 11.4242C13.5334 11.3333 13.3 11.3333 12.8333 11.3333H7.16667C6.69996 11.3333 6.4666 11.3333 6.28834 11.4242C6.13154 11.5041 6.00406 11.6315 5.92416 11.7883C5.83333 11.9666 5.83333 12.2 5.83333 12.6667V18M17.5 8.27124V14C17.5 15.4001 17.5 16.1002 17.2275 16.635C16.9878 17.1054 16.6054 17.4878 16.135 17.7275C15.6002 18 14.9001 18 13.5 18H6.5C5.09987 18 4.3998 18 3.86502 17.7275C3.39462 17.4878 3.01217 17.1054 2.77248 16.635C2.5 16.1002 2.5 15.4001 2.5 14V7C2.5 5.59987 2.5 4.8998 2.77248 4.36502C3.01217 3.89462 3.39462 3.51217 3.86502 3.27248C4.3998 3 5.09987 3 6.5 3H12.2288C12.6364 3 12.8402 3 13.0321 3.04605C13.2021 3.08688 13.3647 3.15422 13.5138 3.2456C13.682 3.34867 13.8261 3.4928 14.1144 3.78105L16.719 6.38562C17.0072 6.67387 17.1513 6.818 17.2544 6.98619C17.3458 7.13531 17.4131 7.29789 17.4539 7.46795C17.5 7.65976 17.5 7.86358 17.5 8.27124Z" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Saved Searches
          </Button>
          <div className="h-6 border-l border-main-border"></div>
          <Button
            type="text"
            onClick={handleRecentClick}
            className={currentIndex === 3 ? "active-tab" : ""}
          >
            <BsSearchSin style={{ fontSize: "20px" }} />
            Recent Searches
          </Button>
          {addTalentPoolTab.map((pool, index) => (
            <Button
              key={pool.id}
              type="text"
              onClick={() => handleTalentPoolClick(pool.id, index)}
              className={currentIndex === index + 4 ? "active-tab" : ""}
            >
              <FaHamburgerSin style={{ fontSize: "20px" }} />
              {pool.name}
            </Button>
          ))}
          {/* <div className="h-6 border-l border-main-border"></div>
                    </Button>
                    {/* <div className="h-6 border-l border-main-border"></div> */}
          {/* <Button type='text' onClick={handleTalentPoolClick} className={currentIndex === 4 ? 'active-tab': ''}>
                        <FaHamburger style={{fontSize: "20px"}} />
                        Talent Pool 1
                    </Button>
                    <div className="h-6 border-l border-main-border"></div>
                    <Button type='text' onClick={handleTalentPoolClick} className={currentIndex === 5 ? 'active-tab': ''}>
                        <FaHamburger style={{fontSize: "20px"}} />
                        Talent Pool 2
                    </Button> */}
          {/* <div className="h-6 border-l border-main-border"></div>
                    <Button type='text' onClick={() => showModal('TalentPool')}>
                        <PlusOutlined style={{fontSize: "20px"}} />
                        Add Talent Pool
                    </Button> */}
          <div className="h-6 border-l border-main-border"></div>
          {/* <Dropdown overlay={contributerEmails} trigger={["click"]}>
                        <Button type='text' icon={<UsersPlusIcon/>}>
                            Contributors<IoMdArrowDropdown />
                        </Button>
                    </Dropdown> */}
          <Dropdown
            overlay={contributerEmails}
            trigger={["click"]}
            disabled={!isAddContributorsAllowed}
          >
            {/* <img src={saveSearch} alt="" style={{fontSize: "20px"}} /> */}
            <Tooltip
              title={
                isAddContributorsAllowed
                  ? ""
                  : "You don't have permission to select / add contributors"
              }
              placement="top"
              overlayClassName="custom-tooltip"
            >
              <Button type="text" icon={<UsersPlusIcon />} disabled={!isAddContributorsAllowed}>
                Contributors <IoMdArrowDropdownSin />
              </Button>
            </Tooltip>
          </Dropdown>
          <div className="h-6 border-l border-main-border"></div>
          <Button
            type="text"
            onClick={handleScreeningClick}
            className={currentIndex === 25 ? "active-tab" : ""}
          >
            <img src={candidateIcon} style={{ width: "25px" }} alt="" />
            {/* <PieChartOutlined style={{fontSize: "20px"}} /> */}
            Screening
          </Button>
          <div className="h-6 border-l border-main-border"></div>
          <Button
            type="text"
            onClick={handleReportsClick}
            className={currentIndex === 10 ? "active-tab" : ""}
          >
            {SvgIcons.folderIcon}
            {/* <PieChartOutlined style={{fontSize: "20px"}} /> */}
            Reports
          </Button>
          {/* <Button type='text' onClick={() => setActiveKey("1")}>
                        <PlusOutlined style={{fontSize: "20px"}} />
                        {SvgIcons.mediumRoundedPlusSvg} Add Talent Pool
                    </Button> */}
          {/* <Flex
                        justify="space-between"
                        align="center"
                        className="border-b border-main-border h-[53px] px-2 gap-2"
                    >
                        <Flex align="center" className="gap-3">
                        <Title4 text="Talent Pools" className="text-text-quaternary font-bold" />
                        {activeKey !== "1" && (
                            <span className="cursor-pointer" onClick={() => setActiveKey("1")}>
                            {SvgIcons.mediumRoundedPlusSvg}
                            </span>
                        )}
                        </Flex>
                        <span
                        className="bg-white p-2 rounded-md"
                        onClick={() => setActiveKey(activeKey === "2" ? null : "2")}
                        >
                        {activeKey === "2" ? SvgIcons.crossArrow : SvgIcons.searchLgSvg}
                        </span>
                    </Flex> */}
          {activeKey && (
            <Flex vertical className="gap-[15px] p-4 bg-bg-primary">
              {formDetails[activeKey]?.map((item) => (
                <Flex vertical className="gap-2" key={item.name}>
                  <span className="text-text-secondary font-bold text-sm flex items-center gap-1">
                    {item.label} <span className="text-primary"> *</span>
                    {item.icon && item.icon}
                  </span>
                  <div className="relative">
                    {item.prefixIcon && (
                      <span className="absolute top-1/2 left-2 -translate-y-1/2">
                        {item.prefixIcon}
                      </span>
                    )}
                    {item.type === "input" ? (
                      <Input
                        placeholder={item.placeholder}
                        className="border-2 rounded-md border-main-border"
                        style={{
                          marginInlineEnd: 4,
                          color: "#344054",
                          display: "flex",
                          alignItems: "center",
                          textTransform: "capitalize",
                          paddingLeft: item.prefixIcon ? "18px" : "",
                          gap: "5px",
                          fontWeight: 500,
                        }}
                        name={item.name}
                        value={formData[item.name as keyof typeof formData]}
                        onChange={handleInputChange}
                      />
                    ) : (
                      <Select
                        placeholder={item.placeholder}
                        optionFilterProp="children"
                        className="border-2 rounded-md border-main-border"
                        variant="borderless"
                        showSearch
                        filterOption={(input, option) =>
                          typeof option?.label === "string" &&
                          option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        style={{
                          marginInlineEnd: 4,
                          color: "#344054",
                          display: "flex",
                          alignItems: "center",
                          textTransform: "capitalize",
                          paddingLeft: item.prefixIcon ? "18px" : "",
                          gap: "5px",
                          fontWeight: 500,
                        }}
                        options={
                          Array.isArray(item.options)
                            ? (item.options as CandidateOption[]).map((opt) => ({
                              value: opt.value,
                              label: opt.label,
                            }))
                            : (item.options as unknown as TalentPool[])?.map((opt) => ({
                              value: opt.owner,
                              label: (
                                <Flex align="center" className="gap-3 px-0">
                                  <Avatar size={24} src={AvatarIcon} />
                                  <span className="text-text-secondary text-sm font-semibold">
                                    {opt.owner}
                                  </span>
                                </Flex>
                              ),
                            })) || []
                        }
                        value={formData[item.name as keyof typeof formData] || undefined}
                        onChange={(value) => handleSelectChange(value, item.name)}
                      />
                    )}
                  </div>
                </Flex>
              ))}
              <Flex gap={15}>
                <Button
                  className="bg-border-tertiary text-text-secondary border flex-grow border-main-border rounded-md py-2"
                  onClick={() => {
                    setActiveKey(null);
                    setFormData({ name: "", jobTitle: "" });
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="bg-primary text-white border flex-grow border-box-border rounded-md py-2"
                  loading={addProjectLoading}
                  onClick={activeKey === "1" ? handleSave : handleSearch}
                  disabled={formData.name.length < 2}
                >
                  {activeKey === "1" ? "Save" : "Apply"}
                </Button>
              </Flex>
            </Flex>
          )}
        </div>
        {/* <Flex align="center" gap={24}>
                    <Button onClick={handleProjectDetailsClick} className={`relative font-semibold text-sm text-gray py-2 px-3 border border-[#875F9A] flex gap-1 rounded-lg group ${currentIndex === 99 ? 'active-tab': ''}`}>
                        <FaEdit style={{fontSize: "20px"}} />
                        Edit Project
                    </Button>
                </Flex> */}
        <Flex align="center" gap={24}>
          {/* {SvgIcons.copySvg}
                    {SvgIcons.deleteSvg} */}
          <Tooltip
            title={isEditAllowed ? "" : "You don't have permission to edit this project"}
            placement="top"
            overlayClassName="custom-tooltip"
          >
            <Button
              onClick={isEditAllowed ? handleProjectDetailsClick : undefined}
              disabled={!isEditAllowed}
              className={`relative font-semibold text-sm text-gray py-2 px-3 border border-[#875F9A] flex gap-1 rounded-lg group ${currentIndex === 99 ? "active-tab" : ""
                } ${!isEditAllowed ? "opacity-50 cursor-not-allowed" : ""}`}
              style={{ backgroundColor: "#F4EBFF", borderColor: "#D6BBFB", color: "#6941C6" }}
            >
              <img src={fingerprintIcon} alt="" />
              Project Details
            </Button>
            {/* <Button
              onClick={isEditAllowed ? handleProjectDetailsClick : undefined}
              disabled={!isEditAllowed}
              className={`relative font-semibold text-sm text-gray py-2 px-3 border border-[#875F9A] flex gap-1 rounded-lg group ${
                currentIndex === 99 ? "active-tab" : ""
              } ${!isEditAllowed ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <FaEditSin style={{ fontSize: "20px" }} />
              Edit Project
            </Button> */}
          </Tooltip>
        </Flex>
      </Flex>
      {/* Dynamic Modal */}
      <Modal
        title={<>{modalType === "Contributor" ? "Add Team Contributor" : "Create Talent Pool"}</>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
        width={320}
      >
        <Form form={form} layout="vertical">
          {modalType === "Contributor" && (
            <Form.Item
              label={<span style={{ color: "darkgray" }}>Contributor E-mail</span>}
              name="email"
              rules={[{ required: true, message: "Please select a contributor email!" }]}
            >
              <Select
                placeholder="Select a contributor email"
                // optionFilterProp="children"
                showSearch
                onChange={(value) => {
                  const selectedContributor = contributors.find(
                    (contributor) => contributor.email === value
                  );
                  selectedContributor && setSelectedContributors(selectedContributor); // Update the state with the selected contributor
                }}

              >
                {/* {contributors.map((contributor) => (
                                    <Select.Option key={contributor.id} value={contributor.email}>
                                        {contributor.email}
                                    </Select.Option>
                                ))} */}
                {contributors.map((contributor) => (
                  <Select.Option
                    key={contributor.id}
                    value={contributor.email}
                    style={{
                      display: "flex", // Use flexbox for row alignment
                      justifyContent: "space-between", // Align name and email with space between
                      alignItems: "center",
                      padding: "8px 12px",
                      borderBottom: "1px solid #e0e0e0", // Divider between options
                    }}
                  >
                    <span>{contributor.name}</span>
                    <span className="mx-1" style={{ color: "gray", fontSize: "12px" }}>
                      {contributor.email}
                    </span>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {modalType === "TalentPool" && (
            <Form.Item
              label={<span style={{ color: "darkgray" }}>Talent Pool Name</span>}
              name="name"
              rules={[{ required: true, message: "Please enter a talent pool name!" }]}
            >
              <Input placeholder="Enter talent pool name" onChange={handleInputChange} />
            </Form.Item>
          )}

          {/* Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={() => {
                form.resetFields();
                setIsModalVisible(false);
              }}
              style={{
                borderRadius: 4,
                width: "120px",
              }}
            >
              Cancel
            </Button>
            <Spin spinning={loading}>
              <Button
                type="primary"
                onClick={modalType === "Contributor" ? handleAddContributor : handleAddTalentPool}
                style={{ backgroundColor: "#7A5AF8", borderRadius: 4, width: "120px" }}
              >
                Save
              </Button>
            </Spin>
          </div>
        </Form>
      </Modal>
      <Modal
        visible={isSuccessModalVisible}
        onCancel={() => setIsSuccessModalVisible(false)}
        footer={null}
        centered
        width={400}
      >
        {modalType === "Contributor" && (
          <div style={{ textAlign: "center" }}>
            <CheckCircleOutlined
              style={{ color: "#52c41a", fontSize: "40px", marginBottom: "20px" }}
            />
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              Contributor Was Successfully Added
            </div>
          </div>
        )}
        {modalType === "TalentPool" && (
          <div style={{ textAlign: "center" }}>
            <CheckCircleOutlined
              style={{ color: "#52c41a", fontSize: "40px", marginBottom: "20px" }}
            />
            <div style={{ fontSize: "18px", fontWeight: "bold" }}>
              Talent Pool Was Successfully Added
            </div>
          </div>
        )}
      </Modal>

      <LimitedAccessModal
        isModalOpen={isLimitedAccessModalVisible}
        hideModal={() => setIsLimitedAccessModalVisible(false)}
        selectedPool={selectedPool}
      />
    </>
  );
};

export default ProjectSavedSearchesSecondHeader;
